import { IOssixProvider } from 'interfaces/otherInterface/dynamicInput';
import {
  ActionType,
  TargetType,
  TransferSourceType,
} from 'types/generalType';

/* eslint-disable @typescript-eslint/no-explicit-any */
interface PayBillsPayloadParm {
  pin?: string;
  amount?: string;
  country?: string;
  inputFormValue?: any;
  provider?: IOssixProvider;
  accountNumber?: string;
  ContactPID?: string;
  gatewayTransferConfirmation?: any;
  transferConfirmation?: any;
  GatewayOperationType?: any;
  sendFundsToGateway?: any;
  FirstName?: string;
  LastName?: string;
  defaultPhoneNumber?: string;
  onSaveBeneficiary?: any;
  saveContact?: boolean;
  formValues?: any;
  otherKeys?: any;
  OTP?: string;
  SelfieURL?: string;
  description?: string;
}

export const PayBillsTransferConfirmation = ({
  inputFormValue,
  provider,
  accountNumber,
  ContactPID,
  country,
  gatewayTransferConfirmation,
  // transferConfirmation,
  GatewayOperationType,
  // onSaveBeneficiary,
  // saveContact,
  amount,
  otherKeys,
  defaultPhoneNumber,
  description,
}: PayBillsPayloadParm) => {
  const { inputField, phoneNumber, ...restFormValues } =
    inputFormValue;

  const payload = gatewayTransferConfirmation({
    ActionType: provider?.ActionType,
    TargetType: TargetType.PayBills,
    Category: provider?.Category,
    GatewayOperationType: GatewayOperationType,
    AccountNumber: accountNumber,
    SourceWallet: '',
    BrandUnikID: provider?.BrandUnikID,
    ShortName: provider?.ShortName,
    Amount: amount,
    SourceType: TransferSourceType.BANK,
    TargetCountryCode: country || '',
    PartnerRequest: {
      reason: description,
      phoneNumber: phoneNumber || defaultPhoneNumber,
      merchant: provider?.OperatorName,
      ...restFormValues,
    },
    TargetAccountNumber: otherKeys.TargetAccountNumber || phoneNumber,
    SendVoucher: provider?.AcceptVoucher,
    ContactPID: ContactPID,
    otherKeys: { ...otherKeys },
  });

  // transferConfirmation(payload);

  const payloay = {
    transferConfirmation: payload,
    saveBenef: {
      ActionType: provider?.ActionType || '',
      CountryCode: country,
      ShortName: provider?.ShortName,
      Category: provider?.Category,
      CustomerID: '',
      AccountNumber:
        inputFormValue?.serviceNumber ||
        inputFormValue?.phoneNumber ||
        '',
      FirstName: provider?.OperatorName || '',
      LastName: '',
      PhoneNumber: phoneNumber || '',
      ...restFormValues,
    },
  };

  return payloay;

  // if (saveContact) {
  //   onSaveBeneficiary({
  //     ActionType: provider?.ActionType || '',
  //     CountryCode: country,
  //     ShortName: provider?.ShortName,
  //     Category: provider?.Category,
  //     CustomerID: '',
  //     AccountNumber:
  //       inputFormValue?.serviceNumber ||
  //       inputFormValue?.phoneNumber ||
  //       '',
  //     FirstName: provider?.OperatorName || '',
  //     LastName: '',
  //     PhoneNumber: phoneNumber || '',
  //     ...restFormValues,
  //   });
  // }
};

export const TransferPayBillsPayload = ({
  FirstName,
  LastName,
  defaultPhoneNumber,
  inputFormValue,
  ContactPID,
  country,
  amount,
  accountNumber,
  sendFundsToGateway,
  pin,
  GatewayOperationType,
  provider,
  formValues,
  otherKeys,
  OTP,
  SelfieURL,
  description,
}: PayBillsPayloadParm) => {
  const { inputField, phoneNumber, ...restFormValues } =
    inputFormValue;

  const { Amount, type, verifyAccount, verifyURL, ...restForm } =
    formValues;

  const payload = {
    PIN: pin,
    DepositorName: '',
    TargetType: TargetType.PayBills,
    GatewayOperationType: GatewayOperationType,
    Category: provider?.Category,
    ActionType: ActionType.PayBills,
    BrandUnikID: provider?.BrandUnikID,
    ShortName: provider?.ShortName,
    SourceWallet: '',
    AccountNumber: accountNumber,
    Amount: amount,
    TargetCountryCode: country,
    FirstName: FirstName || '',
    LastName: LastName || '',
    OperatorID: provider?.OperatorID,
    OperatorName: provider?.OperatorName,
    ServiceRef: '',
    SourceType: TransferSourceType.BANK,
    OTP: OTP,
    SelfieURL: SelfieURL,
    PartnerRequest: {
      reason: description,
      merchant: provider?.ShortName || provider?.OperatorName,
      phoneNumber: phoneNumber || defaultPhoneNumber,
      ...restForm,
      ...restFormValues,
    },
    SendVoucher: provider?.AcceptVoucher,
    TargetAccountNumber:
      otherKeys.TargetAccountNumber ||
      phoneNumber ||
      defaultPhoneNumber,
    ContactPID: ContactPID,
    ...otherKeys,
  };

  sendFundsToGateway(payload);
};
